<script>
export default {
  data() {
    return {
      routerValue: null,
    }
  },
  mounted() {
    const path = window.location.href
    const url = path.includes('home')
    if (url) {
      this.routerValue = true
    }
  },
}
</script>

<template>
  <div id="divLoader">
    <div
      v-if="routerValue"
      class="text-center"
      :class="$style.loaderHomeBackGround"
    >
      <div :class="$style.spnrPosition">
        <b-spinner
          variant="primary"
          :class="$style.homeSpinner"
          label="Text Centered"
        ></b-spinner>
      </div>
    </div>

    <div v-else class="text-center" :class="$style.loaderBackGround">
      <div :class="$style.spnrPosition">
        <b-spinner
          variant="primary"
          :class="$style.spinner"
          label="Text Centered"
        ></b-spinner>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.loaderHomeBackGround {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  min-height: 100%;
  visibility: visible;
  background: rgba(0, 0, 0, 0.1);
  opacity: 1;
  transition: opacity 0.2s;
}
.loaderBackGround {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  min-height: 100%;
  visibility: visible;
  background: rgba(0, 0, 0, 0.1);
  opacity: 1;
  transition: opacity 0.2s;
}
.spnrPosition {
  position: absolute;
  top: 110px;
  right: 0;
  left: 0;
  margin: 0 auto;
}
.spinner {
  width: 5rem;
  height: 5rem;
}
.homeSpinner {
  width: 3rem;
  height: 3rem;
}
</style>
